import { PrecisionFloat } from '@bts-web/utils-formatting';
import { valueFromAssetToFiat } from './valueFromAssetToFiat';
import { valueFromFiatToAsset } from './valueFromFiatToAsset';

interface AssetToAssetInput {
  amount: string;
  fromPrice: PrecisionFloat;
  toPrice: PrecisionFloat;
  customPrecision?: number | null;
}

export const valueFromAssetToAsset = ({
  amount,
  fromPrice,
  toPrice,
  customPrecision,
}: AssetToAssetInput): PrecisionFloat => {
  const sourceFiat = valueFromAssetToFiat(amount, fromPrice);

  const toAssetValue = valueFromFiatToAsset(
    sourceFiat?.value as string,
    toPrice,
    customPrecision,
  );

  return {
    value: toAssetValue.value,
    precision: toAssetValue.precision,
  };
};
